import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useNavigate } from "react-router-dom";

const AuthenticatedLayout = ({ children }) => {
  const user = useSelector((state) => state.user.user);
  const navigator = useNavigate();

  const [allowView, setAllowView] = useState(false);

  useEffect(() => {
    if (!user) {
      navigator("/");
    } else {
      setAllowView(true);
    }
  }, [user]);

  return <>{allowView && <>{children}</>}</>;
};

export default AuthenticatedLayout;